<template>
    <header>
        <div>
            <div class="app-name">
                <rich-logo/>
                <div>
                    <h2>Rich'en Danse</h2>
                    <p>Espace client</p>
                </div>
            </div>
        </div>
        <div>
            <strong v-show="step !== 1">Étape {{ step }}/4</strong>
        </div>
    </header>
</template>

<script>
    import RichLogo from "../a-elements/RichLogo";
    export default {
        name: "RichRegistrationHeader",
        components: {RichLogo},
        props:{
            step:Number,
        }
    }
</script>

<style scoped lang="scss">
header{
    display:flex;
    justify-content: space-between;
    align-items: center;
    top:0;
    left:0;
    width: 100%;
    position: fixed;
    background: white;
    border-bottom: 1px solid var(--color-grey-light-2);
    padding: 16px;
}
.app-name {
    display: flex;
    align-items: center;
    user-select:none;
    > div {
        p {
            margin-bottom: 0;
        }

        h2 {
            line-height: 16px;
            margin-bottom: 0;
        }
    }
}
    @include screen-l{
        header{
            position:initial;
            padding:16px 24px;
        }
    }
</style>
